import DocumentTypePage from './pages/DocumentTypePage'
import FolderPage from './pages/FolderPage'

export const CatalogsRoutes = [
  {
    path: '/tipoDocumento',
    name: 'DocumentType',
    component: DocumentTypePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/carpetas',
    name: 'Folder',
    component: FolderPage,
    meta: {
      requiresAuth: true
    }
  }
]
